<template>
  <el-scrollbar
    ref="bodyScrollbar"
  >
    <RecycleScroller
      :items="formatedImgList"
      key-field="_id"
      :getScrollParent="getTableBodyScrollbarWrap"
      v-slot="{ item }"
      :buffer="1500"
      :minItemSize="cardHeight">
      <div
        class="grid-row"
        :style="{'grid-template-columns': `repeat(${gridSize}, 1fr)`}"
      >
        <RaceImgCard
          v-for="img in item"
          :key="img._id"
          :cropImageView="cropImageView"
          :imgProp="img"
          :height="cardHeight"
          :filters="selectedFilters"
          :raceFilters="raceFilters"
          @selectImg="selectImg"
        />
      </div>
    </RecycleScroller>
  </el-scrollbar>
</template>

<script>
import { debounce } from '@/utils/utils'
import RecycleScroller from '../RecycleScroller'
import RaceImgCard from '../../components/raceImageComponents/RaceImgCard'

const scrollToUpHeight = 100
const scrollToDownHeight = 300

export default {
  name: 'RecycleRaceGallery',
  components: {
    RaceImgCard,
    RecycleScroller
  },
  props: {
    cropImageView: {
      type: Boolean,
    },
    debounceTime: {
      type: Number,
      default: 100,
    },
    gridSize: {
      type: Number,
      default: 4,
    },
    imgList: {
      type: Array,
      required: true
    },
    raceFilters: {
      type: Object,
      default: () => ({}),
    },
    selectedFilters: {
      type: Object,
      required: true
    },
  },
  data() {
    return {
      cardHeight: 0
    }
  },
  computed: {
    formatedImgList() {
      let formatedImages = []
      for (let i = 0; i < this.imgList.length; i += this.gridSize) {
        formatedImages.push(this.imgList.slice(i, i + this.gridSize))
      }
      return formatedImages
    },
  },
  methods: {
    init() {
      this.updateCardHeight()
      window.addEventListener('resize', this.updateCardHeight);
    },
    getScrollWrapper() {
      return this.$el?.querySelector('.el-scrollbar__wrap')
    },
    getTableBodyScrollbarWrap() {
      return this.$refs.bodyScrollbar.$refs.wrap
    },
    updateCardHeight() {
      const { image_height : height, image_width: width } = this.imgList[0]
      const ratio = height && width ? (height / width) : 11/16
      const offsetWidth = this.$refs && this.$refs.bodyScrollbar && this.$refs.bodyScrollbar.wrap ? this.$refs.bodyScrollbar.wrap.offsetWidth : this.gridSize
      this.cardHeight = ((offsetWidth / this.gridSize) * ratio) + 47
    },
    handleScroll(e) {
      const { clientHeight, scrollHeight, scrollTop } = e.target
      const scrollPercentage = Math.round((scrollTop / (scrollHeight - clientHeight)) * 100)

      this.$emit('scroll', scrollPercentage)
      if (scrollTop < scrollToUpHeight) {
        this.$emit('scrollystart')
      }
      if (scrollHeight - clientHeight - scrollTop < scrollToDownHeight) {
        this.$emit('scrollyend')
      }
    },
    selectImg(imgId) {
      this.$emit('selectImg', imgId)
    }
  },
  created() {
    this.debouncedScroll = debounce(this.handleScroll, this.debounceTime)
  },
  mounted() {
    this.init()
    const scrollWrapper = this.getScrollWrapper()
    if (scrollWrapper) {
      scrollWrapper.addEventListener('scroll', this.debouncedScroll)
    }
  },
  beforeDestroy() {
    const scrollWrapper = this.getScrollWrapper()
    if (scrollWrapper) {
      scrollWrapper.removeEventListener('scroll', this.debouncedScroll)
    }
  },
}
</script>

<style lang="scss" scoped>
.grid-row {
  display: grid;
  gap: 10px;
  padding-right: 16px;
}
</style>
